export default {
  key: `${process.env.GATSBY_OPENWEATHER_KEY}`,
  zipCode: "SY39HQ",
  countryCode: "uk",
  latitude: "52.6870",
  longitude: "-2.7640",
}
